import ShrinkableText from './ShrinkableText';

import './index.css';

export default ShrinkableText;
